import axios from 'axios';

import { CLIENT_HEADER_NAME, CLIENT_HEADER_VALUE } from './http-headers';

const httpClient = axios.create();

httpClient.defaults.baseURL = process.env.REACT_APP_API_URL || null;
httpClient.defaults.headers.common[CLIENT_HEADER_NAME] = CLIENT_HEADER_VALUE;

httpClient.interceptors.request.use(
  config => {
    return new Promise(resolve => {
      resolve(config);
    });
  },

  error => {
    return Promise.reject(error);
  }
);

httpClient.interceptors.response.use(
  response => {
    if (
      response &&
      response.hasOwnProperty('data') &&
      response.hasOwnProperty('config')
    ) {
      // console.log(response.config.url, response.data);
    }

    return response;
  },

  error => {
    return Promise.reject(error);
  }
);

export default httpClient;
